import {Flex, Modal} from "antd";
import React from "react";
import '@mdxeditor/editor/style.css';
import {useAppDispatch} from "../../feature/tools";
import {saveProject} from "../../feature/project/projectsSlice";
import {Project} from "../../feature/project/project";
import ProjectGeneralSettings from "./settings/ProjectGeneralSettings";

export interface AddProjectProps {
    project: Project,
    visible: boolean,
    onDismiss: () => void,
}

export const AppProjectModal = (props: AddProjectProps) => {
    const dispatch = useAppDispatch();
    const [pr, setPr] = React.useState(new Project())

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={'Add Project'}
            okText={'Save'}
            okButtonProps={{disabled: !pr?.title}}
            onOk={() => {
                if (pr) {
                    dispatch(saveProject({...pr}))
                    props.onDismiss()
                }
            }}
            onCancel={() => props.onDismiss()}
        >
            <Flex gap={16}>
                <ProjectGeneralSettings
                    onChange={(project) => {
                        setPr(project)
                    }}
                    saveFunction={(saveFunction) => {
                    }}
                />
            </Flex>
        </Modal>
    )
        ;
}